<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@stores/auth';

const props = defineProps({
  userStatus: {
    type: String,
    required: true, 
    default: ''    
  }
});

const emit = defineEmits(['verify', 'showDocumentModal']);

const authStore = useAuthStore();

const isPendingFaceId = computed(() => props.userStatus === 'pending_face_id');
const isPendingKyc = computed(() => props.userStatus === 'pending_kyc');

const shouldShowButton = computed(() => {
  return isPendingFaceId.value || isPendingKyc.value;
});

const buttonText = computed(() => {
  if (isPendingFaceId.value) {
    return 'Verificação Facial Necessária';
  }
  return 'Verificação Necessária';
});

const hasDocument = computed(() => {
  return authStore.user?.document?.number && authStore.user.document.number.trim() !== '';
});

const handleClick = () => {
  // Check if user has CPF first
  if (!hasDocument.value) {
    emit('showDocumentModal');
    return;
  }
  
  // If user has CPF, proceed with verification
  const verificationType = isPendingFaceId.value ? 'face' : 'kyc';
  emit('verify', verificationType);
};
</script>

<template>
  <BaseButton
    v-if="shouldShowButton"
    @click="handleClick"
    :class="[
      'relative group flex items-center text-white h-8 transition-all duration-300 overflow-hidden px-2',
    ]"
    aria-label="Iniciar verificação pendente"
  >
    <div
      class="w-3 h-3 rounded-full bg-red-800 animate-pulse shrink-0"
      aria-hidden="true"
    ></div>
    <div
      class="max-w-0 group-hover:max-w-[200px] transition-all duration-300 overflow-hidden whitespace-nowrap"
    >
      <span class="ml-2 text-xs">{{ buttonText }}</span>
    </div>
  </BaseButton>
</template>

<style scoped>
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>